var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"action-bar"},[_c('my-button',{staticClass:"action-bar__new-phone",attrs:{"title":"New Phone","type":"button","variant":"secondary","on-click":_vm.openNewPhoneEditWindow}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }